import { useFormContextStateSelector } from "../useFormContextStateSelector";

export const useFormButtonContext = () => {
  return useFormContextStateSelector(({ button: {getOnSubmit, buttonText, hidden} }) => 
      ({ getOnSubmit, buttonText, hidden }));
}